import { customAxios } from "./customAxios";

/**
 * 게이트웨이 전체 목록
 * @returns 
 */
export const getGatewaysAll = async()=>{
  const res = await customAxios.get('/api/iotGateways');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 게이트웨이 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getGatewaysByQuery = async(query)=>{
  const res = await customAxios.get('/api/iotGateways', {params : query});
  //console.log(res);
  if (res.data) {
    //console.log(res.data._embedded);
    //console.log(res.data);
    //return Object.values(res.data);
    return res.data;
  }
  return null;
}

/**
 * 게이트웨이 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getGatewaysByQueryString = async(query)=>{
  const res = await customAxios.get('/api/iotGateways'+ query);
  //console.log(res);
  if (res.data) {
    //console.log(res.data._embedded);
    //console.log(res.data);
    //return Object.values(res.data);
    return res.data;
  }
  return null;
}

/**
 * 센서 전체 목록
 * @returns 
 */
export const getSensorsAll = async()=>{
  const res = await customAxios.get('/api/sensors');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 센서 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getSensorsByQuery = async(query)=>{
  //console.log(query);
  const res = await customAxios.get('/api/sensors', {params : query});
  //console.log(res);
  if (res.data) {
    //return Object.values(res.data);
    return res.data;
  }
  return null;
}

/**
 * 센서 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getSensorsByQueryString = async(query)=>{
  //console.log(query);
  const res = await customAxios.get('/api/sensors'+ query);
  //console.log(res);
  if (res.data) {
    //return Object.values(res.data);
    return res.data;
  }
  return null;
}

/**
 * 게이트웨이 상세
 * @param {*} id 
 * @returns 
 */
export const getGatewaysById = async(id)=>{
  const res = await customAxios.get('/api/iotGateways/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 센서 상세
 * @param {*} id 
 * @returns 
 */
export const getSensorsById = async(id)=>{
  const res = await customAxios.get('/api/sensors/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}
